import { render, staticRenderFns } from "./Equivalence.vue?vue&type=template&id=1a0990b2"
import script from "./Equivalence.vue?vue&type=script&lang=js"
export * from "./Equivalence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a0990b2')) {
      api.createRecord('1a0990b2', component.options)
    } else {
      api.reload('1a0990b2', component.options)
    }
    module.hot.accept("./Equivalence.vue?vue&type=template&id=1a0990b2", function () {
      api.rerender('1a0990b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/Equivalence.vue"
export default component.exports